<template>
    <div id="news">
        <Banner title="最新消息" :breadcrumbs="breadcrumbs" type="news"></Banner>
        <div class="bg" :style="`backgroundImage:url(${bgImage})`">
            <div class="container" v-if="!IsDetail">
                <div class="center_title">
                    <Title en="Last News" chtFirst="最新" chtSecond="消息" :center="true"></Title>
                </div>
                <div class="tab">
                    <div
                        class="item"
                        :class="{'active':'All' === Tabselected}"
                        @click="changeTab('All')"
                    >全部訊息</div>
                    <div
                        class="item"
                        v-for="(tab,index) in tabs"
                        :key="index"
                        :class="{'active':tab.Id === Tabselected}"
                        @click="changeTab(tab.Id)"
                    >{{tab.Title}}</div>
                </div>
                <div
                    class="new_box"
                    v-infinite-scroll="loadMore"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                    v-show="news.length > 0"
                >
                    <a
                        class="item"
                        v-for="(item,index) in news"
                        :key="index"
                        :href="`/News?Id=${item.Id}`"
                    >
                        <div
                            class="date"
                        >{{item.StartOn?$moment(item.StartOn).format("YYYY-MM-DD"):""}}</div>
                        <div class="tag">
                            <div>{{getTitle(item.CategoryId)}}</div>
                        </div>
                        <div class="subtitle">{{item.Title}}</div>
                    </a>
                </div>
                <notfound v-if="news.length == 0" info="目前沒有最新相關資訊，"></notfound>
            </div>
            <div class="container animated fadeIn" v-if="IsDetail">
                <div class="detail">
                    <span
                        class="date"
                    >{{Detail.StartOn?$moment(Detail.StartOn).format("YYYY-MM-DD"):''}}</span>
                    <span class="tag">{{Detail.CategoryId?getTitle(Detail.CategoryId):''}}</span>
                    <h3 class="title">{{Detail.Title}}</h3>
                    <div class="strip"></div>
                    <div class="content" v-html="Detail.Content"></div>
                    <div class="btn">
                        <a href="/News">回列表</a>
                    </div>
                </div>
            </div>
        </div>
        <loading v-if="isLoading"></loading>
    </div>
</template>

<script>
import Common from "@/common";
import API from "@/service/news.js";
export default {
    name: "news",
    components: {},
    props: ["propnews"],
    data() {
        return {
            bgImage: require("@/assets/background/news.png"),
            breadcrumbs: [
                {
                    url: "/",
                    title: "首頁"
                },
                {
                    url: "/news",
                    title: "最新消息"
                }
            ],
            tabs: [],
            Tabselected: "All", //當前在哪一個頁簽
            Api: [],
            news: [], //讀取資料用
            IsDetail: false,
            Detail: {
                // CategoryId: "30972f80-ca91-4325-a6e6-ce81ea3bbe42",
                // Content:
                //     "轉知 衛生福利部國民健康署「108年罕見疾病防治工作貢獻獎表揚計畫」甄選訊息。 為鼓勵對罕見疾病防治工作長期耕耘及有具體貢獻之機關、單位或團體，依據罕見疾病防治工作獎勵及補助辦法，規劃本表揚計劃，以彰顯罕見疾病防治人員之典範。惠請於108年7月31日前，依網站所附表揚計畫之推薦表函送國健署，俾辦理審查。 ​本案聯絡人:衛生福利部‧國民健康署徐小姐(地址：臺中市西區民權路95號7樓；電話:04-22172425或04-22172415)；計畫內容及推薦表單等相關訊息，請參閱 國民健康署 網站。",
                // Description: null,
                // EndOn: null,
                // Id: "7aecb625-4870-40af-a46d-4b6b80027ef3",
                // Image: null,
                // Introduction: null,
                // IsInterval: false,
                // Sort: 1,
                // StartOn: "2019-07-19T00:00:00",
                // Tags: null,
                // Title: "中華民國視網膜醫學會民國108年工作計畫",
                // Url: null,
                // Message: null,
                // Ok: true
            },
            busy: false,
            page: 1,
            totalpage: 1,
            isLoading: false
        };
    },
    methods: {
        getTitle(CategoryId) {
            const vm = this;
            // console.log("CategoryId", CategoryId);
            // console.log("分類", vm.tabs);
            let arr = vm.tabs.filter(item => {
                if (item.Id == CategoryId) {
                    return item.Title;
                }
            });
            // console.log(arr);
            return arr[0].Title;
        },
        changeTab(selected) {
            const vm = this;
            if (vm.Tabselected == selected) {
                return false;
            }
            vm.Tabselected = selected;
            // console.log(selected);
            vm.page = 1;
            if (selected === "All") {
                if (process.env.NODE_ENV === "production") {
                    //新聞清單API
                    API.getNewsList({ page: 1, count: 10 }).then(result => {
                        let NewsList = result.Data.News;
                        vm.news = NewsList;
                    });
                } else {
                    vm.news = vm.Api;
                }
            } else {
                if (process.env.NODE_ENV === "production") {
                    //新聞清單API
                    API.getCategoryNewslist({
                        Id: selected,
                        page: 1,
                        count: 10
                    }).then(result => {
                        let NewsList = result.Data.News;
                        vm.news = NewsList;
                    });
                } else {
                    console.log(selected);
                    vm.news = vm.Api.filter(item => {
                        // console.log(item.Id);
                        return item.CategoryId == selected;
                    });
                }
            }
        },
        loadMore() {
            const vm = this;
            vm.busy = true;
            // console.log("總", vm.totalpage);
            // console.log("單", vm.page);
            if (vm.totalpage == vm.page) {
                return false;
            }
            vm.isLoading = true;
            vm.page += 1;
            //全部訊息
            if (vm.Tabselected === "All") {
                API.getNewsList({ page: vm.page, count: 10 }).then(result => {
                    if (result.Data.News.length === 0) {
                        return false;
                    } else {
                        setTimeout(function() {
                            vm.busy = false;
                        }, 1000);
                    }
                    setTimeout(function() {
                        vm.isLoading = false;
                    }, 500);
                    let NewsList = result.Data.News;
                    vm.news = vm.news.concat(NewsList);
                });
            } else {
                //分類訊息
                API.getCategoryNewslist({
                    Id: selected,
                    page: vm.page,
                    count: 10
                }).then(result => {
                    if (result.Data.News.length === 0) {
                        return false;
                    } else {
                        setTimeout(function() {
                            vm.busy = false;
                        }, 1000);
                    }
                    let NewsList = result.Data.News;
                    vm.news = vm.news.concat(NewsList);
                });
            }
        }
    },
    computed: {},
    created() {
        const vm = this;
        let Urlparams = Common.GetUrlParams("Id");
        //獲取分類列表
        if (vm.propnews) {
            API.getNewsCategory()
                .then(result => {
                    vm.tabs = result.Data;
                })
                .then(() => {
                    if (Urlparams) {
                        vm.IsDetail = true;
                        API.getNewsDetail({ Id: Urlparams }).then(result => {
                            if (result.Ok) {
                                vm.Detail = result.Data;
                            } else {
                                location.href = "/News";
                            }
                        });
                    } else {
                        let obj = JSON.parse(vm.propnews);
                        vm.news = obj.News;
                        // console.log("總單數", obj.Total);
                        vm.totalpage = Math.ceil(parseInt(obj.Total) / 10);
                        vm.busy = false;
                    }
                });
        } else {
            let arr = [];
            vm.page = 1;
            vm.totalpage = 1;
            vm.tabs = [
                {
                    Id: "0d740489-c8c0-4f24-9de5-61f5b4f27cbf",
                    Title: "視網膜醫學會"
                },
                {
                    Id: "30972f80-ca91-4325-a6e6-ce81ea3bbe42",
                    Title: "專科考試"
                },
                {
                    Id: "8f7587e8-3649-4dce-a525-c7a54499841d",
                    Title: "國際訊息"
                }
            ];
            vm.news = [
                {
                    Id: "7aecb625-4870-40af-a46d-4b6b80027ef3",
                    StartOn: "2019-01-07",
                    EndOn: "",
                    Sort: "視網膜醫學會",
                    Title: "視網膜醫學會網站 全新改版，會員/準會員 登入說明～",
                    CategoryId: "0d740489-c8c0-4f24-9de5-61f5b4f27cbf"
                },
                {
                    Id: "e9ed7fb0-cf16-4f5e-a9ec-5c6ab6483f39",
                    StartOn: "2019-01-07",
                    EndOn: "",
                    Sort: "專科考試",
                    Title: "中華民國視網膜醫學會 民國108年 工作計畫",
                    CategoryId: "30972f80-ca91-4325-a6e6-ce81ea3bbe42"
                },
                {
                    Id: "abcdefsdasdsdadsadasdasd",
                    StartOn: "2019-01-07",
                    EndOn: "",
                    Sort: "國際訊息",
                    Title: "轉知「醫策會20週年國際論壇」徵文訊息。",
                    CategoryId: "8f7587e8-3649-4dce-a525-c7a54499841d"
                },
                {
                    Id: "abcdefsdasdsdadsadasdasd",
                    StartOn: "2019-01-07",
                    EndOn: "",
                    Sort: "視網膜醫學會",
                    Title: "視網膜醫學會網站 全新改版，會員/準會員 登入說明～",
                    CategoryId: "0d740489-c8c0-4f24-9de5-61f5b4f27cbf"
                },
                {
                    Id: "7aecb625-4870-40af-a46d-4b6b80027ef3",
                    StartOn: "2019-01-07",
                    EndOn: "",
                    Sort: "視網膜醫學會",
                    Title: "視網膜醫學會網站 全新改版，會員/準會員 登入說明～",
                    CategoryId: "0d740489-c8c0-4f24-9de5-61f5b4f27cbf"
                },
                {
                    Id: "e9ed7fb0-cf16-4f5e-a9ec-5c6ab6483f39",
                    StartOn: "2019-01-07",
                    EndOn: "",
                    Sort: "專科考試",
                    Title: "中華民國視網膜醫學會 民國108年 工作計畫",
                    CategoryId: "30972f80-ca91-4325-a6e6-ce81ea3bbe42"
                },
                {
                    Id: "abcdefsdasdsdadsadasdasd",
                    StartOn: "2019-01-07",
                    EndOn: "",
                    Sort: "國際訊息",
                    Title: "轉知「醫策會20週年國際論壇」徵文訊息。",
                    CategoryId: "8f7587e8-3649-4dce-a525-c7a54499841d"
                },
                {
                    Id: "7aecb625-4870-40af-a46d-4b6b80027ef3",
                    StartOn: "2019-01-07",
                    EndOn: "",
                    Sort: "視網膜醫學會",
                    Title: "視網膜醫學會網站 全新改版，會員/準會員 登入說明～",
                    CategoryId: "0d740489-c8c0-4f24-9de5-61f5b4f27cbf"
                },
                {
                    Id: "e9ed7fb0-cf16-4f5e-a9ec-5c6ab6483f39",
                    StartOn: "2019-01-07",
                    EndOn: "",
                    Sort: "專科考試",
                    Title: "中華民國視網膜醫學會 民國108年 工作計畫",
                    CategoryId: "30972f80-ca91-4325-a6e6-ce81ea3bbe42"
                },
                {
                    Id: "abcdefsdasdsdadsadasdasd",
                    StartOn: "2019-01-07",
                    EndOn: "",
                    Sort: "國際訊息",
                    Title: "轉知「醫策會20週年國際論壇」徵文訊息。",
                    CategoryId: "8f7587e8-3649-4dce-a525-c7a54499841d"
                },
                {
                    Id: "7aecb625-4870-40af-a46d-4b6b80027ef3",
                    StartOn: "2019-01-07",
                    EndOn: "",
                    Sort: "視網膜醫學會",
                    Title: "視網膜醫學會網站 全新改版，會員/準會員 登入說明～",
                    CategoryId: "0d740489-c8c0-4f24-9de5-61f5b4f27cbf"
                },
                {
                    Id: "e9ed7fb0-cf16-4f5e-a9ec-5c6ab6483f39",
                    StartOn: "2019-01-07",
                    EndOn: "",
                    Sort: "專科考試",
                    Title: "中華民國視網膜醫學會 民國108年 工作計畫",
                    CategoryId: "30972f80-ca91-4325-a6e6-ce81ea3bbe42"
                },
                {
                    Id: "abcdefsdasdsdadsadasdasd",
                    StartOn: "2019-01-07",
                    EndOn: "",
                    Sort: "國際訊息",
                    Title: "轉知「醫策會20週年國際論壇」徵文訊息。安安",
                    CategoryId: "8f7587e8-3649-4dce-a525-c7a54499841d"
                }
            ];
            if (Urlparams.Id) {
                vm.IsDetail = true;
            }
        }
    },
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#news .bg {
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    padding: 60px 0;
}

/* .container {
  width: 80%;
  margin: auto;
} */
#news .center_title {
    text-align: center;
    margin: auto;
    padding: 20px 0;
}
#news .tab {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
}
#news .tab .item {
    padding: 2px 10px;
    color: #666;
    cursor: pointer;
}
#news .tab .item.active {
    color: #ee8b59;
}
#news .tab .item + .item {
    border-left: 1px solid #333;
}
#news .new_box {
    padding: 20px 0 0;
    min-height: 500px;
}
#news .new_box .item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 30px;
    background-color: #fff;
    margin-bottom: 15px;
    cursor: pointer;
    border-radius: 5px;
    transition: 0.35s;
    color: #666;
    text-decoration: none;
}
#news .new_box .item:hover {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
#news .new_box .item .date {
    width: 10%;
    text-align: center;
}
#news .new_box .item .tag {
    width: 20%;
    text-align: center;
}
#news .new_box .item .tag div {
    width: 110px;
    margin: auto;
    background-color: #a68d79;
    padding: 5px;
    border-radius: 5px;
    color: #fff;
}
#news .new_box .item .subtitle {
    width: 70%;
    font-weight: 500;
}
#news .detail {
    background-color: #fff;
    padding: 60px 30px 90px;
}
#news .detail .date {
    color: #666;
    padding-right: 15px;
}
#news .detail .tag {
    background-color: #a68d79;
    display: inline-block;
    color: #fff;
    padding: 5px;
    border-radius: 5px;
    width: 110px;
    text-align: center;
}
#news .detail .title {
    color: #666;
    padding: 20px 0;
    line-height: 1.5;
}
#news .detail .strip {
    width: 5px;
    height: 25px;
    background-color: #a68d79;
}
#news .detail .content {
    color: #666;
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    overflow: auto;
}
#news .detail .content >>> h1,
#news .detail .content >>> h2,
#news .detail .content >>> h3,
#news .detail .content >>> h4,
#news .detail .content >>> h5,
#news .detail .content >>> h6,
#news .detail .content >>> p,
#news .detail .content >>> span {
    line-height: 1.5;
    letter-spacing: 2px;
}
#news .detail .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;
}
#news .detail .btn a {
    display: inline-block;
    color: #fff;
    background-color: #ee8b59;
    padding: 10px 25px;
    cursor: pointer;
    text-decoration: none;
}
@media screen and (max-width: 1200px) {
    #news .new_box .item .date {
        width: auto;
        padding-right: 15px;
        text-align: left;
    }
    #news .new_box .item .tag {
        width: auto;
    }
    #news .new_box .item .subtitle {
        width: 100%;
        padding: 10px 0;
        line-height: 1.5;
    }
}
@media screen and (max-width: 992px) {
    /* .container {
    width: 90%;
    margin: auto;
  } */
    #news .new_box .item .subtitle {
        padding: 10px 0;
    }
}
@media screen and (max-width: 767px) {
    #news .tab:after {
        content: "";
        flex: 1;
    }
    #news .tab .item {
        width: 50%;
        margin-bottom: 10px;
        text-align: center;
    }
    #news .tab .item:nth-child(3) {
        border: none;
    }
    #news .new_box {
        padding: 20px 0 0;
    }
    #news .new_box .item {
        padding: 20px 10px;
    }

    .none {
        display: none;
    }
    #news .detail {
        padding: 30px 10px;
    }
    #news .detail .title {
        font-size: 1.3rem !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/news.vue